/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Rule2_CondInputs */

const tr_landing_pricerules_mock_rule2_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat farkı 50₺'yi aşarsa`)
};

const en_landing_pricerules_mock_rule2_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price gap exceeds ₺50`)
};

const de_landing_pricerules_mock_rule2_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preisdifferenz über 50 ₺`)
};

const ru_landing_pricerules_mock_rule2_cond = /** @type {(inputs: Landing_Pricerules_Mock_Rule2_CondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разница в цене больше 50 ₺`)
};

/**
* | output |
* | --- |
* | "Price gap exceeds ₺50" |
*
* @param {Landing_Pricerules_Mock_Rule2_CondInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_rule2_cond = /** @type {((inputs?: Landing_Pricerules_Mock_Rule2_CondInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Rule2_CondInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_rule2_cond(inputs)
	if (locale === "de") return de_landing_pricerules_mock_rule2_cond(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_rule2_cond(inputs)
	return tr_landing_pricerules_mock_rule2_cond(inputs)
});